export default __webpack_public_path__ + "static/media/iStar.135ac588.svg";